import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApiWe, WeClient } from '@api/api';
import { TranslateService } from '@ngx-translate/core';
import {
  Observable,
  of,
  Subject,
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  catchError,
  concat,
  filter,
} from 'rxjs';

@Component({
  selector: 'app-we-search',
  templateUrl: './we-search.component.html',
  styleUrls: ['./we-search.component.scss'],
})
export class WeSearchComponent implements OnInit {
  @Output() public enter = new EventEmitter();

  @Output() public weChange = new EventEmitter<ApiWe>();

  @Output() public weListChange = new EventEmitter<ApiWe[]>();

  @Input() public isSelect = true;

  @Input() public disabled = false;

  public weList$: Observable<ApiWe[]> = of([]);

  public weListLoading = false;

  public weListTypeahead$: Subject<string> = new Subject<string>();

  public weSearchFormControl = new FormControl();

  public selectedWe: ApiWe | null = null;

  public constructor(public translateService: TranslateService, public weClient: WeClient) {}

  /**
   * Function to load list of WEs from the database using typeahead
   */
  public loadWes(): void {
    this.weList$ = concat(
      of([]),
      this.weListTypeahead$.pipe(
        filter(value => value !== null && value !== ''),
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => (this.weListLoading = true)),
        switchMap(term => {
          return this.weClient.find(term).pipe(
            catchError(() => of([])),
            tap(() => (this.weListLoading = false))
          );
        })
      )
    );
  }
  /**
   * Sets weList$ on init
   */
  public ngOnInit(): void {
    this.loadWes();

    if (!this.isSelect) {
      this.weSearchFormControl.valueChanges.subscribe((value: string) => {
        this.weListTypeahead$.next(value);
      });
      this.weList$.subscribe((weList: ApiWe[]) => {
        this.weListChange.emit(weList);
      });
    }
  }

  /**
   * Emits weChange event when WE is selected
   * @param we Selected WE
   */
  public onChange(we: ApiWe) {
    this.weChange.emit(we);
  }
}
